module.exports = __webpack_public_path__ + "static/media/img-328b51bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-avatar.png
// module id = 5267
// module chunks = 39